import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "toggle"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#toggle" }),
  /*#__PURE__*/_createTextVNode(" Toggle ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Click on the below buttons to toggle the button active state and rotate the icons accordingly: ", -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 90 deg ")
const _hoisted_7 = { class: "svg-icon svg-icon-2 rotate-90 ms-3" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 180 deg ")
const _hoisted_9 = { class: "svg-icon svg-icon-2 rotate-180 ms-3" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 270 deg ")
const _hoisted_11 = { class: "svg-icon svg-icon-2 rotate-270 ms-3" }
const _hoisted_12 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_CodeHighlighter2 = _resolveComponent("CodeHighlighter2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.click($event))),
          type: "button",
          class: "btn btn-primary me-5 rotate",
          id: "kt_button_1"
        }, [
          _hoisted_6,
          _createVNode("span", _hoisted_7, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-to-right.svg" })
          ])
        ]),
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.click($event))),
          type: "button",
          class: "btn btn-danger me-5 rotate",
          id: "kt_button_2"
        }, [
          _hoisted_8,
          _createVNode("span", _hoisted_9, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-to-right.svg" })
          ])
        ]),
        _createVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.click($event))),
          type: "button",
          class: "btn btn-success me-5 rotate",
          id: "kt_button_3"
        }, [
          _hoisted_10,
          _createVNode("span", _hoisted_11, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-to-right.svg" })
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_CodeHighlighter2, null, {
        html: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.html), 1)
        ]),
        js: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.js), 1)
        ]),
        _: 1
      })
    ])
  ]))
}